<script>
import { mapState } from 'vuex'
/* eslint-disable-next-line */
import ScaleQuiz from '@/components/ScaleQuiz.vue'
import Scale from '@/components/Scale.vue'

export default {
  components: {
    ScaleQuiz, Scale
  },
  computed: {
    ...mapState(['notes', 'soundHelper'])
  },
  data () {
    return {
      myNotes: this.$store.state.notes.filter(note => note.solfege === 'do' || note.solfege === 're' ||
    note.solfege === 'mi' || note.solfege === 'fa')
    }
  },
  methods: {
    playNote (freq, solfege) {
      this.soundHelper.playSound(freq, solfege, 500)
    }
  }

}
</script>

<template>
  <div>
    <Scale :notes="myNotes" :noteClicked="playNote" />
    <ScaleQuiz :notes="myNotes" :playNote="playNote" />
  </div>
  </template>
